import { initialAbilities } from '~/libs/acl/abilityConfig';

export const initialAbility = [...initialAbilities];

export const _ = undefined
